export const LOAD_CATEGORY_LIST = 'LOAD_CATEGORY_LIST';
export const SET_CATEGORY_LIST_LOADING_STATUS = 'SET_CATEGORY_LOADING_STATUS';
export const LOAD_CATEGORY_ISSUE_LIST = 'LOAD_CATEGORY_ISSUE_LIST';
export const SET_CATEGORY_ISSUE_LIST_LOADING_STATUS = 'SET_CATEGORY_ISSUE_LIST_LOADING_STATUS';
export const SET_CATEGORY_ACTION_LOADING_STATUS = 'SET_CATEGORY_ACTION_LOADING_STATUS';
